// File State Helper Utilities
// Pure functions for file state transformations

/**
 * Updates a file in the files array
 * @param {Array} files - Array of files
 * @param {string} fileId - File ID to update
 * @param {Object} updates - Updates to apply
 * @returns {Array} - Updated files array
 */
export function updateFileInArray(files, fileId, updates) {
  return files.map(file => 
    file.id === fileId ? { ...file, ...updates } : file
  );
}

/**
 * Adds a file to the files array
 * @param {Array} files - Array of files
 * @param {Object} newFile - New file to add
 * @returns {Array} - Files array with new file added
 */
export function addFileToArray(files, newFile) {
  return [...files, newFile];
}

/**
 * Removes a file from the files array
 * @param {Array} files - Array of files
 * @param {string} fileId - File ID to remove
 * @returns {Array} - Files array with file removed
 */
export function removeFileFromArray(files, fileId) {
  return files.filter(file => file.id !== fileId);
}

/**
 * Format file creation date for display (e.g. "Jan 16")
 * @param {string} createdAt - ISO date string
 * @returns {string} - Formatted date like "MMM DD"
 */
export function formatFileCreatedDate(createdAt) {
  if (!createdAt) return '';
  try {
    return new Date(createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch {
    return '';
  }
}

/**
 * Whether to show creation date suffix for a file (when multiple files share the same name)
 * @param {Array} files - All files
 * @param {string} fileName - File name to check
 * @returns {boolean}
 */
export function shouldShowFileCreatedDate(files, fileName) {
  if (!files || !fileName) return false;
  const count = files.filter(f => f.name === fileName).length;
  return count > 1;
}
